import { GlobalModalProvider } from "Components/CommonComponent/GlobalModal/GlobalModal";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "simplebar-react/dist/simplebar.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./slices/store";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        {/* <GlobalModalProvider> */}
        <App />
        {/* </GlobalModalProvider> */}
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);

reportWebVitals();
